import { render, staticRenderFns } from "./CreateAppointmentForm.vue?vue&type=template&id=7b0ace0b&scoped=true&"
import script from "./CreateAppointmentForm.vue?vue&type=script&lang=ts&"
export * from "./CreateAppointmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAppointmentForm.vue?vue&type=style&index=0&id=7b0ace0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ace0b",
  null
  
)

export default component.exports